import { render, staticRenderFns } from "./dialog-eds-iit-checkbox.vue?vue&type=template&id=859faa1a&scoped=true&lang=pug"
import script from "./dialog-eds-iit-checkbox.vue?vue&type=script&lang=js"
export * from "./dialog-eds-iit-checkbox.vue?vue&type=script&lang=js"
import style0 from "./dialog-eds-iit-checkbox.vue?vue&type=style&index=0&id=859faa1a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "859faa1a",
  null
  
)

export default component.exports